export default __webpack_public_path__ + "static/media/Pancake.084956d4.svg";